import { useQueryContext } from 'modules/billing/contexts/QueryContext';
import { useMetricInfo } from 'modules/billing/hooks/useMetricInfo';
import { AnalyticCard } from '../AnalyticCard';
import { ProjectBreakdownLink } from '../ProjectBreakdownLink';
import {
  CUSTOM_EVENTS_CARD_IDS,
  CUSTOM_EVENTS_CARD_TEXT,
  CUSTOM_EVENTS_METRIC_NAMES,
} from './constants';

const {
  cardTitle,
  projectBreakdownUrl,
  totalCustomEventsDescription,
  totalCustomEventsName,
  totalCustomEventsHighWatermarkDescription,
  totalCustomEventsHighWatermarkName,
} = CUSTOM_EVENTS_CARD_TEXT;

export const CustomEventsUsageCard = () => {
  const { isLoading } = useQueryContext();
  const [totalCustomEventsHighWatermarkInfo, totalCustomEventsInfo] = useMetricInfo(
    CUSTOM_EVENTS_METRIC_NAMES,
  );

  const cardMetrics = [
    {
      limit: totalCustomEventsInfo.annualLimit,
      metricDescription: `${totalCustomEventsDescription} ${totalCustomEventsInfo.dateRangeText}`,
      metricName: totalCustomEventsName,
      metricValue: totalCustomEventsInfo.value,
      timePeriod: totalCustomEventsInfo.annualLimit
        ? 'maximum'
        : totalCustomEventsInfo.dateRangeText,
    },
    {
      // no limit for high watermark, so no progress bar will be shown
      limit: totalCustomEventsHighWatermarkInfo.annualLimit,
      metricDescription: `${totalCustomEventsHighWatermarkDescription} ${totalCustomEventsHighWatermarkInfo.dateRangeText}`,
      metricName: totalCustomEventsHighWatermarkName,
      metricValue: totalCustomEventsHighWatermarkInfo.value,
      timePeriod: totalCustomEventsHighWatermarkInfo.annualLimit
        ? 'maximum'
        : totalCustomEventsHighWatermarkInfo.dateRangeText,
    },
  ];

  return (
    <AnalyticCard
      CardAction={<ProjectBreakdownLink to={projectBreakdownUrl} />}
      data-test={CUSTOM_EVENTS_CARD_IDS.cardId}
      isLoading={isLoading}
      metrics={cardMetrics}
      title={cardTitle}
    />
  );
};
